<div class="success-container">
  <div class="thumb-icon">
    <img src="assets/apointment.png" alt="Success">
  </div>

  <div class="message">✨ Appointment created successfully</div>

  <div class="info-card">
    <div class="info-text">
      <div class="name">{{ data.name }}</div>
      <div class="details">
        <span class="date">{{ data.date }}</span> ·
        <span class="time">{{ data.time }}</span> ·
        <span class="duration">{{ data.duration }}</span>
      </div>
    </div>
  </div>
</div>
